import React from "react";
import {ProposalFields} from "./add_proposal_steps/ProposalFields";
import {AddProposalServices} from "./add_proposal_steps/AddProposalServicesTabs";
import {AddSettings} from "./add_proposal_steps/AddSettings";
import {Form, Icon, message, Modal, Steps} from "antd";

const moment = require('moment');
const Step = Steps.Step;


class AddUpdateProposalForm extends React.Component {
    state = {
        data: [],
        visible: false,
        service_date: moment().format('YYYY-MM-DD'),
        confirmLoading: false,
        proposal: {},
        current: 0,
    };
    completeForm = () => {
        message.success('Proposal Added Successfully!');
        this.props.setModelVisible();
        this.setState({current: 0})
    }
    onCloseMdl = () => {
        this.props.setModelVisible();
        this.setState({current: 0})
    }
    setProposal = (data) => {
        this.setState({proposal: data});
    };


    next() {
        const current = this.state.current + 1;
        this.setState({current});
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({current});
    }

    render() {
        const {current, proposal} = this.state;
        const {getFieldDecorator} = this.props.form;
        const steps = [{
            title: 'Generator/BillTo Info',
            content: <ProposalFields onClose={() => this.onCloseMdl()}
                                     onNext={() => this.next()} setProposal={(data) => this.setProposal(data)}/>,
            icon: <Icon type="bars"/>
        }, {
            title: 'Service Info',
            content: <AddProposalServices onClose={() => this.onCloseMdl()} onNext={() => this.next()}
                                          onBack={() => this.prev()} proposal={proposal.id}/>,
            icon: <Icon type="solution"/>
        }, {
            title: 'Settings & Analysis',
            content: <AddSettings onClose={() => this.onCloseMdl()} onNext={() => this.next()}
                                  onBack={() => this.prev()} proposal={proposal.id}/>,
        },];
        return (
            <Modal title={"Create Proposal"} style={{top: 5}} className="create-quote-btn step-modal"
                   visible={this.props.visible} onCancel={() => this.onCloseMdl()} footer={false}
                   width="95%" destroyOnClose={true}>
                <div className="row m-0">
                    <div className="col-12 step-work-form">
                        <Steps current={current}>
                            {steps.map(item => <Step key={item.title} title={item.title}/>)}
                        </Steps>
                        <div className="steps-content">{steps[current].content}</div>
                    </div>
                </div>
            </Modal>

        );
    }
}

export const AddUpdateProposal = Form.create()(AddUpdateProposalForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/AddUpdateProposal.jsx